import { render } from "./Waters.vue?vue&type=template&id=6d4e009c"
import script from "./Waters.vue?vue&type=script&lang=js"
export * from "./Waters.vue?vue&type=script&lang=js"

import "./Waters.vue?vue&type=style&index=0&id=6d4e009c&lang=css"
script.render = render

export default script